module.exports = __webpack_public_path__ + "static/media/Highgate Close N6 (4).499e8a0f.JPG";